import type { App } from 'vue';

import Vue3TouchEvents from 'vue3-touch-events';

export function bootVue3TouchEvents({ app }: { app: App<Element> }): void {
	app.use(Vue3TouchEvents, {
		disableClick: true,
		swipeTolerance: 100,
	});
}
